import { useFormik } from 'formik'
import { useModal } from 'hooks'
import _ from 'lodash'
import { useEffect } from 'react'

export const useAddVehicleModal = ({
  onHandleClickUpdate,
  fuel_type,
  hvTcoData,
  replacement_electric_vehicle_chassis,
  ice_chassis,
  onHandleClickAddvehicle,
  heavy_vehicle_weight_class,
}: any) => {
  const { closeModal } = useModal()

  const onHandleAddVehicle = async (values: any) => {
    const {
      heavy_vehicle_weight_class,
      make,
      model,
      variant,
      payload,
      range,
      efficiency,
      service_cost_km,
      tyre_cost_km,
      chassis_cost,
      battery,
    } = values

    const data = {
      make: make,
      model: model,
      heavy_vehicle_weight_class: heavy_vehicle_weight_class,
      gvm: 6500,
      payload: payload,
      passenger_max_for_comparison: '0',
      fuel_type: fuel_type,
      power_max: '108',
      battery: battery,
      range: range,
      efficiency: efficiency / 100,
      charging: '22',
      charge_time: 360,
      battery_warranty: '',
      chassis_cost: chassis_cost,
      service_cost_km: service_cost_km,
      tyre_cost_km: tyre_cost_km,
      field18: '',
      variant: variant,
    }

    if (
      values.ice_chassis === 'custom' ||
      values.replacement_electric_vehicle_chassis === 'custom'
    ) {
      await onHandleClickAddvehicle(data)
      await closeModal('add-vehicle-modal')
      return
    }

    await onHandleClickUpdate({ ...values, efficiency: efficiency / 100 }, values.id)
    await closeModal('add-vehicle-modal')
  }

  const initialValues = {
    make: '',
    model: '',
    heavy_vehicle_weight_class: heavy_vehicle_weight_class,
    gvm: '',
    payload: '',
    passenger_max_for_comparison: '',
    fuel_type: '',
    power_max: '',
    battery: '',
    range: '',
    efficiency: '',
    charging: '',
    charge_time: '',
    battery_warranty: '',
    chassis_cost: '',
    service_cost_km: '',
    tyre_cost_km: '',
    field18: '',
    ice_chassis: ice_chassis,
    replacement_electric_vehicle_chassis: replacement_electric_vehicle_chassis,
  }

  const formik = useFormik({
    initialValues: initialValues,
    onSubmit: (values) => onHandleAddVehicle(values),
    enableReinitialize: true,
  })

  useEffect(() => {
    const is_ice = fuel_type === 'diesel'
    const {
      ice_chassis: ice_vehicle_formik,
      replacement_electric_vehicle_chassis: ev_vehicle_formik,
    } = formik.values

    const find_by_id = is_ice
      ? formik.values.ice_chassis
      : formik.values.replacement_electric_vehicle_chassis

    const findElement = _.find(hvTcoData, { id: find_by_id })

    const updateEfficiency = findElement?.efficiency && {
      efficiency: findElement.efficiency * 100,
    }

    if (ev_vehicle_formik !== 'custom' || ice_vehicle_formik !== 'custom') {
      formik.setValues({
        ...findElement,
        ice_chassis: formik.values.ice_chassis,
        replacement_electric_vehicle_chassis: formik.values.replacement_electric_vehicle_chassis,
        ...updateEfficiency,
      })
    }

    if (ice_vehicle_formik === 'custom' || ev_vehicle_formik === 'custom') {
      formik.setValues({
        ...initialValues,
        heavy_vehicle_weight_class: heavy_vehicle_weight_class,
        ice_chassis: formik.values.ice_chassis,
        replacement_electric_vehicle_chassis: formik.values.replacement_electric_vehicle_chassis,
        ...updateEfficiency,
      })
    }
  }, [formik.values.ice_chassis, formik.values.replacement_electric_vehicle_chassis, hvTcoData]) //eslint-disable-line

  useEffect(() => {
    formik.setFieldValue('ice_chassis', ice_chassis)
    formik.setFieldValue(
      'replacement_electric_vehicle_chassis',
      replacement_electric_vehicle_chassis,
    )
  }, []) //eslint-disable-line

  return {
    formik,
  }
}
